import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import translate from '../../../commonComponents/translate';
import SessionProp from '../propTypes/sessionProp';

function AcademySessionMap({ session }) {
  const { classroom } = session;
  const { address } = classroom;
  const { location } = address;
  const center = address.address;
  const a = center.replace(/ /g, '+');
  const b = a.split(',+').join(',');
  return (
    <div className="session-more-information">
      <div
        className={cx('session-info-extra')}
      >
        <div>
          <div id="map">
            <img
              src={`https://maps.googleapis.com/maps/api/staticmap?center=${b}&zoom=13&size=600x400&maptype=roadmap
&markers=color:red%7Clabel:%7C${location[1]},${location[0]}
&key=AIzaSyDalDJYhVtS9zESl6OHGxWgJiBeI6Otiho`}
              alt="Google Maps"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

AcademySessionMap.propTypes = {
  session: PropTypes.shape(SessionProp.propType).isRequired,
};

export default translate(AcademySessionMap);
